import { render, staticRenderFns } from "./tab0.vue?vue&type=template&id=d67df918&scoped=true"
import script from "./tab0.vue?vue&type=script&lang=js"
export * from "./tab0.vue?vue&type=script&lang=js"
import style0 from "./tab0.vue?vue&type=style&index=0&id=d67df918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67df918",
  null
  
)

export default component.exports